import { $, html } from 'rune-ts';
import klass from './input.module.scss';

export const controlErrorMessage = (el$: HTMLElement, message?: string) => {
  const error_message$ = $(el$).find(`.${klass.error_message}`);
  if (message) {
    error_message$?.setTextContent(message).addClass(klass.show);
  } else {
    error_message$?.setTextContent('').removeClass(klass.show);
  }
};

export const required_html = html`
  <div class="${klass.required}">
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
      <circle cx="2" cy="2" r="2" fill="#1C75FF" />
    </svg>
  </div>
`;
